'use client';

import { motion } from 'framer-motion';
import { useState } from 'react';
import classes from './ToolTip.module.css';

const ToolTip = (props) => {
	const { text, header, children, position } = props;
	const [showTooltip, setShowTooltip] = useState(false);

	return (
		<>
			<div
				className={classes.toolTip}
				onMouseEnter={() => setShowTooltip(true)}
				onMouseLeave={() => setShowTooltip(false)}
			>
				{children}

				{showTooltip && (
					<div
						className={
							position === 'right'
								? classes.toolTipWrapperRight
								: classes.toolTipWrapper
						}
					>
						<motion.div
							initial={{ opacity: 0, y: -10 }}
							animate={{ opacity: 1, y: 0 }}
							transition={{ duration: 0.2 }}
							className={classes.toolTipBox}
						>
							{header && (
								<span className={classes.toolTipHeader}>{header}</span>
							)}
							<span className={classes.toolTipText}>{text}</span>
						</motion.div>
					</div>
				)}
			</div>
		</>
	);
};
export default ToolTip;
